import { splitVerseLines, tokenizeLine, tokenizeParagraph } from './tokenizeVerse';

const MEANING_WORDS_PER_LINE = 7;

export function buildSlokaLyricLines(slokaText) {
  const lines = splitVerseLines(slokaText);
  let globalIndex = 0;

  return lines.map((line, lineIndex) => {
    const words = tokenizeLine(line).map((word) => ({
      word,
      globalIndex: globalIndex++
    }));
    return {
      id: `sloka-${lineIndex}`,
      section: 'sloka',
      lineIndex,
      words
    };
  });
}

export function buildMeaningLyricLines(meaningText, wordsPerLine = MEANING_WORDS_PER_LINE) {
  const allWords = tokenizeParagraph(meaningText);
  const lines = [];

  for (let i = 0; i < allWords.length; i += wordsPerLine) {
    const chunk = allWords.slice(i, i + wordsPerLine);
    lines.push({
      id: `meaning-${lines.length}`,
      section: 'meaning',
      lineIndex: lines.length,
      words: chunk.map(({ word, globalIndex }) => ({ word, globalIndex }))
    });
  }

  return lines;
}

export function findActiveLineIndex(lines, activeWordIndex) {
  if (activeWordIndex < 0 || lines.length === 0) return 0;

  const found = lines.findIndex((line) =>
    line.words.some((w) => w.globalIndex === activeWordIndex)
  );

  if (found >= 0) return found;

  const last = lines[lines.length - 1];
  const lastIndex = last.words[last.words.length - 1]?.globalIndex ?? 0;
  if (activeWordIndex > lastIndex) return lines.length - 1;

  return 0;
}

export function seekTimeForWord(globalIndex, totalWords, duration) {
  if (!totalWords || !duration) return 0;
  return (globalIndex / totalWords) * duration;
}
